import React from "react";
import PlanSidePanel from "../../../shared/PlanSidePanel";
import { useWorkoutPlan } from "../../store/useWorkoutPlan";
import WorkoutAnalysisContent from "./WorkoutAnalysisContent";

/**
 * The post-workout analysis in the platform's 450px side panel, titled with
 * the session's name, over the page — the details pane keeps showing the
 * entry the session belongs to. Opened from a Wearable Data widget.
 */
const WorkoutAnalysisPanel = () => {
  const { analysis, closeAnalysis } = useWorkoutPlan();

  return (
    <PlanSidePanel
      open={!!analysis}
      onClose={closeAnalysis}
      title={analysis?.title ?? "Workout analysis"}
    >
      <WorkoutAnalysisContent />
    </PlanSidePanel>
  );
};

export default WorkoutAnalysisPanel;
